import * as React from "react";
import {Button, ControlLabel, FormControl, FormGroup, Modal} from "react-bootstrap";
import {FormattedMessage, InjectedIntl, InjectedIntlProps, injectIntl} from "react-intl";
import {LcdIcon} from "../../common/ui/icon/LcdIcon";
import {Role} from "../../user/model";

interface State {
  showModal: boolean;
  role: string;
  description: string;
}

interface Props extends InjectedIntl, InjectedIntlProps {
  disabled: boolean;
  initialRoleName?: string;
  initialDescription?: string;
  onSuccess: (entry: Role) => void;
}

export class NewRoleButtonPresentation extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      role: "",
      description: "",
    };
  }

  closeModal = () => this.setState({...this.state, showModal: false});

  submitModal = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    if (typeof this.props.onSuccess === "function") {
      if (this.state.role.trim().length > 1) {
        this.props.onSuccess(
            {
              role: this.state.role.trim(),
              description: this.state.description.trim(),
            } as Role);
        this.closeModal();
      }
    }
  }

  openModal = () => {
    this.setState({
      role: this.props.initialRoleName ? this.props.initialRoleName : "",
      description: this.props.initialDescription ? this.props.initialDescription : "",
      showModal: true
    });
  }

  private handleChange = (event: any) => {
    event.preventDefault();
    const {name, value} = event.target;
    if (name === "role") {
      const noSpecialChars = value.replace(/[^\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF\w'-]+/g, '');
      event.target.value = noSpecialChars;
      this.setState({
        ...this.state,
        role: noSpecialChars
      });
    } else {
      // @ts-ignore
      this.setState({
        [name]: value
      })
    }
  }

  render() {
    return (
        <>
          <Button className="user-tour-add-data-root-button" onClick={this.openModal}>
            <LcdIcon icon={"plus"}/>
            <FormattedMessage id="studio.roles.roles-button.add" defaultMessage="Add role"/>
          </Button>

          <Modal show={this.state.showModal} onHide={this.closeModal} bsSize="large" backdrop="static">
            <Modal.Header closeButton>
              <Modal.Title>
                <FormattedMessage id="studio.users.new-role.modal-header"
                                  defaultMessage="Enter new role information"
                />
              </Modal.Title>
            </Modal.Header>
            <form onSubmit={this.submitModal}>
              <Modal.Body>
                <FormGroup controlId="group-rolename-id">
                  <ControlLabel>
                    <FormattedMessage id="studio.users.new-role.label-rolename"
                                      defaultMessage="Role name"
                    />
                  </ControlLabel>
                  <FormControl autoFocus type="text" name="role" value={this.state.role} onChange={this.handleChange}
                               required={true}/>
                </FormGroup>
                <FormGroup controlId="group-role-description-id">
                  <ControlLabel>
                    <FormattedMessage id="studio.users.new-role.label-description"
                                      defaultMessage="Description"
                    />
                  </ControlLabel>
                  <FormControl type="text" name="description" value={this.state.description}
                               onChange={this.handleChange} required={true}/>
                </FormGroup>
              </Modal.Body>
              <Modal.Footer>
                <Button type="submit">
                  <FormattedMessage
                      id="studio.users.new-role.button.ok"
                      defaultMessage="OK"
                  />
                </Button>
                <Button onClick={this.closeModal}>
                  <FormattedMessage
                      id="studio.users.new-role.button.close"
                      defaultMessage="Cancel"
                  />
                </Button>
              </Modal.Footer>
            </form>
          </Modal>
        </>
    );
  }
}

export const NewRoleButton = injectIntl(NewRoleButtonPresentation);